import { validatePasswords } from "../Helpers/helperLogin";
import { triggerNotifications } from "../Helpers/helperMessages";
import { Logger } from "../logging/Logger";
import { MESSAGE_FROM } from "../constants/Notifications";

export const loginAgent = (user, password, that) => {
  const { apiCont, sharedData, errorEvents } = that;
  const objectResponse = apiCont.getObjectResponse();
  const ipAddress = sharedData.getIPfromAPI();

  apiCont.agentLogin({ user, password, ipAddress, isRemote: true }, objectResponse);

  objectResponse.onSuccess = (objResponse) => {
    const { user, parameters, permissions, generalPermissions } = objResponse.Response;

    sharedData.setUserData(user);
    sharedData.setParameters(parameters);
    sharedData.setPermissions(permissions);
    sharedData.setGeneralPermissions(generalPermissions);
    sharedData.setAllowMarksPermission(permissions.AllowMarks);
    sharedData.setRequestTimeout(generalPermissions[226]);

    const [,, , , volumeSpeaker, volumeMic] = generalPermissions[131].split("|");
    sharedData.setVolumeSpeaker(volumeSpeaker);
    sharedData.setVolumeMic(volumeMic);

    that.setParameters();
    that.connectRabbitMQ();
  };

  objectResponse.onError = (messageError) => {
    Logger.Warning(
      "[AgentSDK] [ResponseFromServer] [Error] [Login][loginAgent] Error Login => ",
      messageError.Message
    );

    errorEvents.errorLogin(messageError);

    triggerNotifications(
      that,
      messageError.InternalCode,
      messageError.Type,
      MESSAGE_FROM.CW,
      messageError.Message
    );
  };
};

export const changePassword = (password, confirmPassword, newPassword, that) => {
  const isValidPassword = validatePasswords(password, newPassword, confirmPassword);

  if (!isValidPassword.isValid) {
    that.svrEvents.onChangePassword(isValidPassword);
    return;
  }

  const { apiCont, sharedData, svrEvents } = that;
  const objectResponse = apiCont.getObjectResponse();
  const userID = sharedData.getParameters().UserID;

  apiCont.changePassword(userID, password, confirmPassword, newPassword, objectResponse);

  objectResponse.onError = (messageError) => {
    Logger.Warning(
      "[AgentSDK] [ResponseFromServer] [Error] [password][changePassword] Error change password => ",
      messageError
    );
    svrEvents.onChangePassword(messageError);
  };

  objectResponse.onSuccess = (objResponse) => {
    svrEvents.onChangePassword(objResponse);
  };
};
